export default "__VITE_ASSET__850f775d__"